import { MinusIcon, PlusIcon } from '@rsos/assets/icons';
import {
  ChatHeaderBox,
  ChatHeader,
  ToggleBox,
  ToggleButton,
} from './CallAutomationAlertChatHeader.styles';

export const CALL_AUDIO_TRANSCRIPT = 'Call Audio Transcript';

const CallAutomationAlertChatHeader = ({
  isChatBoxVisible = true,
  onActionButtonClick = () => {},
}) => (
  <ChatHeaderBox
    data-name="call-automation-alert-chat-header"
    isChatBoxVisible={isChatBoxVisible}
  >
    <ChatHeader data-name="call-automation-alert-chat-title">
      {CALL_AUDIO_TRANSCRIPT}
    </ChatHeader>
    <ToggleBox>
      <ToggleButton
        data-name="call-automation-alert-chat-box-toggle"
        onClick={onActionButtonClick}
      >
        {isChatBoxVisible ? (
          <MinusIcon width={12} height={12} color="secondaryText" />
        ) : (
          <PlusIcon width={14} height={14} color="secondaryText" />
        )}
      </ToggleButton>
    </ToggleBox>
  </ChatHeaderBox>
);

export default CallAutomationAlertChatHeader;
